import React from 'react'
import { BrowserRouter, Route } from 'react-router-dom'
import Login from './pages/Login/Login';
import Chooser from './pages/Chooser/Chooser';
import Mixer from './pages/Mixer/Mixer';

const App: React.FC = () => {
    return (
        <BrowserRouter>
            <Route exact path="/" component={Login} />
            <Route path="/chooser" component={Chooser} />
            <Route path="/mixer" component={Mixer} />
        </BrowserRouter>
    )
}

export default App;